import { initialState } from '../initialState'
import { createReducer } from '@reduxjs/toolkit'
import { settingsActionType } from '../actions/settings'

/**
 * @returns {StateSettingsType} New Settings state.
 */
const settings = createReducer(initialState.settings, {
  [settingsActionType.SET_CURRENT_LANGUAGE]: (state, action) => {
    state.language = action.payload.language
  },

  [settingsActionType.CLEAR_NOTICE]: (state, action) => {
    state.clearedNotices.push(action.payload)
  },

  [settingsActionType.SET_CAMPUS]: (state, action) => {
    state.campus = action.payload.value
  },

  [settingsActionType.SET_ACADEMIC_PERIOD]: (state, action) => {
    state.academicPeriod = action.payload.value
  },

})

export default settings
